import { createVNode as e, mergeProps as l } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/HospitalFilledStandard.js";
import d from "../components/PfIcon.js";
const t = (r, a) => {
  const o = {
    ...r,
    ...a.attrs
  };
  return e(d, l(o, {
    icon: i
  }), null);
};
t.displayName = "HospitalFilledStandard";
t.inheritAttrs = !1;
export {
  t as default
};
